import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Modal, Input } from "antd";
import { Radio, Select } from "antd";

// const options = [
//   {
//     label: '₹500',
//     value: '₹500',
//   },
//   {
//     label: '₹1500',
//     value: '₹1500',
//   },
//   {
//     label: '₹2000',
//     value: '₹2000',
//   },
//   {
//     label: '₹2500',
//     value: '₹2500',
//   },
// ];
// const { Option } = Select;

// const handleChange = (value) => {
//   console.log(`Selected: ${value}`);
// };

const PrepaidCredit = () => {
  const [size, setSize] = useState("middle");

  const handleSizeChange = (e) => {
    setSize(e.target.value);
  };

  return (
    <div className="prepaid-wrap">
      <div className="rightbar-title">Prepaid Credit</div>

      <Row>
        <Col md={12} sm={12}>
          <div className="prepaid-content-wrap">
            <Row>
              <Col lg={6}>
                <Input placeholder="Enter your amount" />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Radio.Group value={size} onChange={handleSizeChange}>
                  <Radio.Button value="default">₹500</Radio.Button>
                  <Radio.Button value="small">₹1500</Radio.Button>
                  <Radio.Button value="medium">₹2000</Radio.Button>
                  <Radio.Button value="large">₹2500</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PrepaidCredit;
